import styled from "styled-components";

const OrderSuccessStyles = styled.div`
    margin: 30px 0;
    .order-success-main {
        min-height: 300px;
    }
`;

export default OrderSuccessStyles;
